import { useSyncExternalStore } from "react";

/**
 * ═══════════════════════════════════════════════════════════════
 *  手机版 / 网页版
 * ═══════════════════════════════════════════════════════════════
 *
 * 🔴 **这两套是分开写的页面，不是同一份 DOM 加一堆 `lg:` 类名。**
 *
 *    手机版和网页版的**信息结构本来就不一样**：
 *    - 商品列表：手机是"品类横滑条 + 两列瀑布流"；网页是"左侧筛选栏 + 右侧网格"
 *    - 购物车：手机是一张张卡片竖排；网页是表格 + 右侧固定的金额汇总
 *    - 账户/商家端：手机是一行行的列表项；网页是左侧导航 + 右侧内容区
 *
 *    把手机那份撑到 1200 宽再多排两列，只是**把页面拉长拉宽**，
 *    不是网页版 —— 该有的密度、该有的并排比较、该有的固定导航一个都没有。
 *
 * ⚠️ **URL 两边共用**：同一个地址在手机和电脑上都打得开，
 *    分享出去的链接、二维码、返回上一级全都不受影响。
 *    分成两套路由的话这些立刻全断。
 */

/** 网页版的起点。⚠️ 平板竖屏（768）走手机版 —— 那个宽度放不下左右分栏。 */
const DESKTOP = "(min-width: 1024px)";

function subscribe(cb: () => void): () => void {
  const mql = window.matchMedia(DESKTOP);
  mql.addEventListener("change", cb);
  return () => mql.removeEventListener("change", cb);
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(DESKTOP).matches,
    /** ⚠️ 没有 window 时（预渲染）当手机 —— 手机版在宽屏上还能看，反过来不行。 */
    () => false,
  );
}
